export const LANDING_URL_DOWNLOAD = "https://societe.app/download";
